/* El servidor dirige cada respuesta con emitter.to(socketId), así que el id del
   socket es lo único que conecta un request con su respuesta.

   Se guarda en memoria y no en localStorage por dos razones:

   1. localStorage es compartido entre pestañas. Con dos pestañas abiertas la
      segunda pisaba el id de la primera, y la respuesta de una llegaba al socket
      de la otra.
   2. Cuando el navegador bloquea el almacenamiento -- WebView in-app de otra
      app, modo privado, cookies de terceros deshabilitadas -- el id no se podía
      guardar y el servidor terminaba emitiendo a una sala vacía: el usuario
      quedaba esperando para siempre.

   El id además solo es válido mientras dure la conexión actual: no hay nada que
   persistir entre recargas, porque al reconectar el socket recibe uno nuevo. */

let currentSocketId = null;

export const setSocketId = (socketId) => {
  currentSocketId = socketId;
};

export const clearSocketId = () => {
  currentSocketId = null;
};

export const getSocketId = () => currentSocketId;
